import CertificationsTemplate from "../../../Templates/Main/Certifications/Certifications.Template";

const CertificationsPage = () => {
    return ( 
        <CertificationsTemplate/>
     );
}
 
export default CertificationsPage;